export default class GeoIP {
  static async get() {
    if (window.UserGeolocation && window.UserGeolocation.country_code) {
      return new Promise((resolve) => resolve(window.UserGeolocation));
    }

    return this.cache();
  }

  static async cache() {
    let data = null;

    try {
      data = await GeoIP.pinpoint();
    } catch (e) {
      console.warn(e);
    }

    // use logged in customer country if available
    if (!data || (typeof data === 'object' && Object.keys(data).length === 0)) {
      if (window.SlrsIdentify) {
        data = window.SlrsIdentify.country;
      }
    }

    if (data) {
      window.UserGeolocation = data;
    }

    return new Promise((resolve) => {
      resolve(data);
    });
  }

  static async pinpoint() {
    const response = await fetch(this.endpoint());
    const data = await response.json();

    return data;
  }

  static endpoint() {
    return 'https://geo-ip.solarisjapan.com/';
  }
}
